export const LANG_CHANGE = "LANG_CHANGE";
export const SET_FETCH = "SET_FETCH";
export const MAIL_SENT = "MAIL_SENT";
export const RESET_KEY_VALIDITY = "RESET_KEY_VALIDITY";
export const RESET_SUCCESSFUL = "RESET_SUCCESSFUL";
export const RESET_ERROR = "RESET_ERROR";
